<div (click)="changeSwitchState()"
    class="smartgui-switch">
    <ng-container *ngIf="smartguiService.switch || smartguiService.switchOceanProtect; else offTemplate">
        <div class="smartgui-switch-icon smartgui-switch-on"
            [nTooltip]="switchEnableTip">
        </div>
    </ng-container>
    <ng-template #offTemplate>
        <div class="smartgui-switch-icon smartgui-switch-off"
            [nTooltip]="switchUnableTip">
        </div>
    </ng-template>
</div>
